export default __webpack_public_path__ + "static/media/auto-fueltype.67a7588f.svg";